import { Navigate } from 'react-router-dom'

// Home — the root authenticated route. For Phase 8 it just redirects
// into the Glows list; we keep the file as the redirect target so it
// can grow into a real dashboard later without a route rename.
export function Home() {
  return <Navigate to="/glows" replace />
}
